<template>
    <div>
        Download Excel file of all emails
    </div>
</template>

<script>
    export default {
        name: 'email-report',
    }
</script>


// WEBPACK FOOTER //
// Emails.vue?1781f5af